import axios from "axios";

// Set axios base URL from environment (dev/prod)
const baseURL = process.env.REACT_APP_API_BASE_URL
if (baseURL) {
  axios.defaults.baseURL = baseURL
}

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        const { token } = JSON.parse(userInfo);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("userInfo");
        localStorage.removeItem("cartItems");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};
